import React, { useCallback } from 'react';
import { FileUploadError, FileUploadV2 } from 'components/FileUploadV2/FileUploadV2';
import { FormField } from 'components/FormField/FormField';
import { VStack } from 'components/layouts/primitives/Stack/Stack';
import { Text } from 'components/Text/Text';
import { snackbarV2Error } from 'services/snackbarV2';
import { useCodeframesModalBLoC } from '../../CodeframesModal.bloc';

export const CodeframesModalFile: React.FC = () => {
  const { form, isEditCodeframe, isAdmin } = useCodeframesModalBLoC();

  const showError = useCallback((invalidFiles: FileUploadError[] | null) => {
    if (invalidFiles) {
      const file = invalidFiles[0].file;
      const title = `${invalidFiles.length === 1 ? file.name : 'Your files'} ${
        invalidFiles[0].type === 'format'
          ? `couldn’t be uploaded`
          : `exceed${invalidFiles.length === 1 ? 's' : ''} the maximum file size of 10MB`
      }`;
      snackbarV2Error({ title });
    }
  }, []);

  return (
    <FormField
      form={form}
      controller={{
        name: 'files',
        rules: !isEditCodeframe
          ? {
              required: 'File is required',
            }
          : {},
      }}
    >
      {({ field, fieldState }) => (
        <VStack gap="gap5">
          <FileUploadV2
            hideLabel
            hideFileUploadListEmptyState
            maxFiles={1}
            accept={isAdmin ? '.csv,.txt' : '.csv'}
            value={field.value}
            onChange={(files) => field.onChange(files)}
            invalid={fieldState.invalid}
            fileSizeLimit={10485760}
            onError={showError}
            description={
              <Text color="neutral400" size="fontSizeXS" lineHeight="lineHeightSM">
                Supports .csv only.
              </Text>
            }
            chooseButtonLabel="Upload file"
          />
        </VStack>
      )}
    </FormField>
  );
};
